import React from 'react';
import { CellRendererParams } from 'routes/BudgetModule/config/types';
import TextHoverTooltip from './TextHoverTooltip';

export default function TextFieldCellRenderer({
    value,
}: CellRendererParams<unknown, string>): React.ReactElement {
    return <TextHoverTooltip value={value} />;
}
